module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive--dark-c9d83692b171fed788015bee82332332.png";